<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/oficinas/${organizationId}/editar`">Códigos</Link>
      <span class="text-orange-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="code.deleted_at" class="mb-6" @restore="restore"> Este código ha sido eliminado. </trashed-message>
    <div class="2xl:flex">
      <div class="w-full min-w-3xl bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="update">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre" />
            <text-input v-model="form.business_name" :error="form.errors.business_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Razón Social" />
          </div>
          <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
            <button v-if="!code.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Eliminar código</button>
            <loading-button :loading="form.processing" class="btn-orange ml-auto" type="submit">Actualizar código</loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    organizationId: Number,
    code: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.code.name,
        business_name: this.code.business_name,
      }),
    }
  },
  methods: {
    getUserName(user) {
      return user.first_name + ' ' + user.last_name
    },
    update() {
      this.form.put(`/codigos/${this.code.id}`)
    },
    destroy() {
      if (confirm('¿Estas seguro que quieres eliminar este código?')) {
        this.$inertia.delete(`/codigos/${this.code.id}`)
      }
    },
    restore() {
      if (confirm('¿Estas seguro que quieres restaurar este código?')) {
        this.$inertia.put(`/codigos/${this.code.id}/restaurar`)
      }
    },
  },
}
</script>
